import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";

const Menu = () => {

  const { city, county, state, label } = useSelector(s => s.local?.location) || {};
  const display = city || county || state || label || 'California';

  return (
                <ul>
                  <li><Link className="nav-link" to={`/local/${encodeURIComponent(display)}`}>Local</Link></li>    
                  <li><Link className="nav-link" to="/categoryimage/news">News</Link></li>
                  <li><Link className="nav-link" to="/category/politics">Politics</Link></li>
                  <li><Link className="nav-link" to="/category/business">Business</Link></li>
                  <li><Link className="nav-link" to="/category/education">Education</Link></li>
                  <li><Link className="nav-link" to="/category/technology">Technology</Link></li>
                  <li><Link className="nav-link" to="/category/finance">Finance</Link></li>
                  <li><Link className ="nav-link" to="/category/sports">Sports</Link></li>
                  <li><Link className ="nav-link" to="/category/travel">Travel</Link></li>
                  <li><Link className ="nav-link" to="/category/lifestyle">Lifestyle</Link></li>
                  <li><Link className ="nav-link" to="/category/wellbeing">Wellbeing</Link></li>
                  <li><Link className ="nav-link" to="/category/kids">Kids</Link></li>
                  <li><Link className ="nav-link" to="/category/pets">Pets</Link></li>
                  <li><Link className ="nav-link" to="/category/home">Home</Link></li>
                  <li><Link className="nav-link" to="/category/games">Games</Link></li>
                  <li><Link className ="nav-link" to="/category/humor">Humor</Link></li>
                  
                  
                  
                </ul>
  );
};

export default Menu;
